module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/reports/leave/Filters.ejs -->\n<form class="filters form-inline m-t-md m-b-md">\n    <div class="form-group m-t-sm m-l-md">\n        <label class="form-label m-r-sm">Date Range</label>\n        <select name="period" class="js-period form-control">\n            <option value="current" '+
((__t=( filters.period === 'current' ? 'selected' : ''))==null?'':_.escape(__t))+
'>\n                Current Balance\n            </option>\n            <option value="previous" '+
((__t=( filters.period === 'previous' ? 'selected' : ''))==null?'':_.escape(__t))+
'>\n                Previous Balance\n            </option>\n            <option value="custom" '+
((__t=( filters.period === 'custom' ? 'selected' : ''))==null?'':_.escape(__t))+
'>\n                Custom Date\n            </option>\n        </select>\n        <div class="date input-group js-datepicker">\n            <span class="input-group-addon">\n                <span class="glyphicon glyphicon-calendar"></span>\n            </span>\n            <input class="form-control js-datepicker-input" name="customEndDate"\n                value="'+
((__t=( filters.customEndDateFormatted ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( filters.period === 'custom' ? '': 'disabled' ))==null?'':_.escape(__t))+
'>\n        </div>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md">\n        <label class="form-label m-r-sm">Leave Type</label>\n        <select name="leave-type" class="js-type form-control">\n            ';
 leaveTypes.forEach(function (type) { 
__p+='\n                <option value="'+
((__t=( type.id ))==null?'':_.escape(__t))+
'"\n                        '+
((__t=( filters['leaveType'] === type.id ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                    '+
((__t=( type.get('name') ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md">\n        <label class="form-label m-r-sm">Group By</label>\n        <select class="form-control js-group-by">\n            <option value="employee">Employee</option>\n        </select>\n\n        <div class="form-group">\n            <select name="employee" class="form-control js-employee chosen-select"\n                multiple data-placeholder="All employees">\n                ';
 employees.forEach(function(employee) { 
__p+='\n                    <option value="'+
((__t=( employee.id ))==null?'':_.escape(__t))+
'"\n                        '+
((__t=( _.contains(filters['employee[]'], employee.id) ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n\n                        '+
((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
'\n                    </option>\n                ';
 }) 
__p+='\n            </select>\n        </div>\n    </div>\n\n    <div class="form-group m-t-sm m-l-md pull-right">\n        <div class="btn-group">\n            <button type="button" class="btn btn-default js-filter-clear">\n                <i class="fa fa-undo"></i>\n                CLEAR\n            </button>\n\n            <button type="button" class="btn btn-primary js-filter-apply">\n                <i class="fa fa-refresh"></i>\n                FILTER\n            </button>\n        </div>\n    </div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/reports/leave/Filters.ejs
// module id = 829
// module chunks = 1